// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// For Production access 
//   export const Envsetting = {
//     production: false,
//     api_url: 'https://mssidcapi.mahait.org/api/',
//     apiBaseUrl: 'https://mssidcapi.mahait.org',
//     companyId: '1254863933218p0ppp'
// };


/*For UAT Legacy Data access */
            export const Envsetting = {
            production: false,
            api_url: 'https://mssidcapi.mahaitgov.in/api/',
            apiBaseUrl: 'https://mssidcapi.mahaitgov.in',
            companyid: '1254863933218p0ppp'
            };




  
/*For UAT access */
            // export const Envsetting = {
            // production: false,
            // api_url: 'https://mssidcapiuat.mahaitgov.in/api/',
            // apiBaseUrl: 'https://mssidcapiuat.mahaitgov.in',
            // companyid: '1254863933218p0ppp'
            // };



/*For TEST access */
// export const Envsetting = {
//  production: false,
//  api_url: 'https://mssidcapi.mahaitgov.in/api/',
//  apiBaseUrl: 'https://mssidcapi.mahaitgov.in',
//  companyId: '1254863933218p0ppp'
// };

/*For Local access */
//  export const Envsetting = {
//  production: false,
//  api_url: 'https://localhost:7015/api/',
//  apiBaseUrl: 'https://localhost:7015',
//  companyid: '1254863933218p0ppp'
//  };


export const Envsetting_local = {
  production: false,
  api_url: 'https://localhost:7015/api/',
  apiBaseUrl: 'https://localhost:7015',
  companyId: '1254863933218p0ppp'
};


export const environment = {
  production: false,
  api_url: 'https://localhost:7015/api/',
  apiBaseUrl: 'https://localhost:7015/api/',
  companyId: '1254863933218p0ppp'
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.


